import { addOrUpdateUniqueStyleTagBeforeSpecificElementInHead } from "@/lib/canvas/assets/dom-utils";
import { prefixBuilderAddedCssTagId } from "@/lib/canvas/assets/css-in-head/utils";

export function addOrUpdateGeneratedStylesInCanvasHead(
  canvasDocument: Document,
  name: string,
  cssString: string
) {
  addOrUpdateUniqueStyleTagBeforeSpecificElementInHead(
    canvasDocument,
    prefixBuilderAddedCssTagId(name),
    cssString,
    `meta[name="breakdance:header-assets:css:${name}"][content="end"]`
  );
}
